export default __webpack_public_path__ + "static/media/diag_divd.e3bb05cc.svg";